import { FormValues } from './types';
import { OuterApiConfigUpdateRequest } from 'src/api/types';

export const transform = (values?: FormValues): OuterApiConfigUpdateRequest => {
    const { requestParams, ...restParams } = values || {};

    return {
        ...restParams,
        requestQueryList: requestParams?.requestQueryList,
        requestHeaderList: requestParams?.requestHeaderList,
        requestBodyList: requestParams?.requestBodyList,
    };
};

export const transformBack = (values?: OuterApiConfigUpdateRequest): FormValues => {
    const { requestQueryList, requestHeaderList, requestBodyList, ...restParams } = values || {};

    return {
        ...restParams,
        requestParams: {
            requestQueryList,
            requestHeaderList,
            requestBodyList,
        },
    };
};
